export class GridApiRegistry {
  private static _map = new Map<string, any>();
  static set(id: string, api: any): void { this._map.set(id, api); }
  static get(id: string): any | null { return this._map.get(id) ?? null; }
  static delete(id: string): void { this._map.delete(id); }
}